module.exports = __webpack_public_path__ + "assets/img/snaprestart.fbd0465a.png";